export const RESPONDENT_STATUS = {
    MEDICAL_CLEARED: "Medical Cleared",
};
export var MANAGER_RESPONDENTS_ASSIGNMENT_TYPE;
(function (MANAGER_RESPONDENTS_ASSIGNMENT_TYPE) {
    MANAGER_RESPONDENTS_ASSIGNMENT_TYPE["PRIMARY"] = "PRIMARY";
    MANAGER_RESPONDENTS_ASSIGNMENT_TYPE["SECONDARY"] = "SECONDARY";
})(MANAGER_RESPONDENTS_ASSIGNMENT_TYPE || (MANAGER_RESPONDENTS_ASSIGNMENT_TYPE = {}));
export const MANAGER_RESPONDENTS_ASSIGNMENT_TYPE_OPTIONS = {
    [MANAGER_RESPONDENTS_ASSIGNMENT_TYPE.PRIMARY]: {
        id: MANAGER_RESPONDENTS_ASSIGNMENT_TYPE.PRIMARY,
        label: "Primary",
    },
    [MANAGER_RESPONDENTS_ASSIGNMENT_TYPE.SECONDARY]: {
        id: MANAGER_RESPONDENTS_ASSIGNMENT_TYPE.SECONDARY,
        label: "Secondary",
    },
};
export const RESPONDENT_VALID_CUSTOM_FIELDS = [
    "custom01",
    "custom02",
    "custom03",
    "custom04",
    "custom05",
    "custom06",
    "custom07",
    "custom08",
    "custom09",
    "custom10",
];
//# sourceMappingURL=respondent.js.map